import { trackReportAdClick } from '@/lib/tracking/tracking';
import { replacePropsWithPreview } from '../../utils';

export type FooterProps = {
    adId: number;
    heading: string | null;
    modified: string | null;
    isPreview?: boolean;
};

export const Footer = ({ adId, heading, modified, isPreview }: FooterProps) => {
    const handleReportAdClick = () => trackReportAdClick(adId.toString(), heading ?? undefined);

    return (
        <div className="mx-0" data-testid="adFooter">
            <table className="mb-24">
                <tbody>
                    <tr>
                        <th className="text-left whitespace-nowrap p-0">FINN-kode</th>
                        <td className="pl-16">
                            <span data-testid="footerAdId">{adId}</span>
                        </td>
                    </tr>
                    {modified && (
                        <tr>
                            <th className="text-left whitespace-nowrap p-0">Sist endret</th>
                            <td className="pl-16" data-testid="lastModified">
                                {modified}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <a
                data-testid="reportAd"
                {...replacePropsWithPreview(
                    {
                        href: `/report/ad?adId=${adId}`,
                        rel: 'external',
                        onClick: handleReportAdClick,
                    },
                    Boolean(isPreview),
                )}>
                Rapporter annonse
            </a>
        </div>
    );
};
